import { ChangeDetectorRef, Component, EventEmitter, Output, Input, TemplateRef } from "@angular/core";
import { WizardComponent } from "ngx-wizard";
import { Order } from "../../../../../objects/orders/order";
import { CalculatorHelper } from "../../../../../common/helpers/calculatorHelper";
import { OrderItem } from "../../../../../objects/orders/orderItem";
import { CanadianCurrencyCode } from "../../../../../objects/currencyExchange/canadianCurrencyCode";
import { GoogleTagService } from "../../../../../services/google-tag.service";
import createNumberMask from 'text-mask-addons/dist/createNumberMask'
import { PageVisit } from "../../../../../objects/pages/pageVisit";

@Component({
    selector: "price-tab-v2",
    templateUrl: "./price-tab-v2.component.html",
    moduleId: module.id.toString()
})
export class PriceTabV2Component {
    @Input()
    public wizardComponent: WizardComponent;

    @Input()
    public order: Order;

    @Input()
    public orderItem: OrderItem;

    @Input()
    public canadianCurrencyCodes: CanadianCurrencyCode[] = [];

    @Input()
    public wizardFooterTemplate: TemplateRef<any>;
    @Input()
    public focusInput: any;
    @Output()
    public onTabSelected: EventEmitter<PageVisit> = new EventEmitter<PageVisit>();

    public currentValue?: string = null;
    public currentValueRange?: number = null;
    public currency: CanadianCurrencyCode;

    public numberMask = createNumberMask({
        prefix: '',
        allowDecimal: true
    });

    /*getters*/
    public get isVehicle(): boolean {
        return CalculatorHelper.isVehicle(this.order);
    }

    /*getters end*/

    constructor(
        private detectChanges: ChangeDetectorRef, 
        public googleTagService: GoogleTagService) {
    }

    public setPrice(from: number, to: number): void {
        this.currentValueRange = <number>CalculatorHelper.getButtonValue(CalculatorHelper.getMeanValue(from, to), this.currentValueRange);

        this.currentValue = null;

        this.detectChanges.detectChanges();
    }

    public setPriceToOI(): void {


        if (this.currentValue)
            this.orderItem.Price = +(this.currentValue.replace(new RegExp(',', 'g'), ''));


        this.orderItem.CanadianCurrencyCode = this.currency;
    }

    public getMeanValue = (from: number, to: number) => CalculatorHelper.getMeanValue(from, to);

    public setCurrency(currencyName: string) {
        this.currency = this.canadianCurrencyCodes.find(code => code.Name == currencyName);
    }

    public checkAndSetCurrency(): void {
        // const calculatorType = CalculatorHelper.getCalculatorType(this.order.Locations);
        //
        // if (calculatorType == CalculatorType.UsaImport)
        //     this.setCurrency('CAD');
        // else this.setCurrency('USD');

        //According to BB-1745 default currency must be 1745
        this.setCurrency('USD');

        if (this.orderItem.Price === undefined || this.orderItem.Price === null){
            this.currentValueRange = null;
        }
    }

    public decimalHandler(event: any) {

        const val = event.target.value + String.fromCharCode(event.charCode);

        // (event.charCode != 0) For Mozilla Firefox

        if (!/^[0-9]+([,.][0-9]{0,2})?$/.test(val) && (event.charCode != 0)) {
            event.preventDefault();
        }
    }


}



// WEBPACK FOOTER //
// ./app/components/calculator/public/mobile/price-tab/price-tab-v2.component.ts